import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { http, formatApiError } from "@/lib/api";
import { formatDateTime } from "@/lib/format";
import { Panel } from "@/components/admin/PageBits";

const fieldCls = "border-white/10 bg-black/30 text-slate-100";

export const RedeemPanel = ({ req, onChanged }) => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [busy, setBusy] = useState(false);

  const openDialog = async () => {
    try {
      const { data } = await http.get("/admin/settings");
      setTitle(data.default_redeem_message.title);
      setContent(data.default_redeem_message.content);
      setOpen(true);
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const complete = async () => {
    setBusy(true);
    try {
      await http.post(`/admin/requests/${req.id}/redeem/complete`, { title, content });
      toast.success("Resgate concluído e mensagem enviada ao cliente.");
      setOpen(false);
      onChanged();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };

  const done = req.redeem_completion;
  return (
    <Panel title="Resgate imediato" testId="redeem-panel">
      {done ? (
        <div className="space-y-1" data-testid="redeem-completed-info">
          <p className="text-sm font-semibold text-emerald-300">{done.title}</p>
          <p className="whitespace-pre-line text-sm text-slate-300">{done.content}</p>
          <p className="text-xs text-slate-500">{done.operator?.name} · {formatDateTime(done.at)}</p>
        </div>
      ) : (
        <button onClick={openDialog} className="btn-gold h-10 px-4 text-sm" data-testid="redeem-complete-btn"><CheckCircle2 className="h-4 w-4" /> Concluir resgate</button>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="border-white/10 bg-[#141C2E] text-slate-100">
          <DialogHeader>
            <DialogTitle>Concluir resgate</DialogTitle>
            <DialogDescription className="text-slate-400">Mensagem final exibida imediatamente ao cliente. Variáveis: {"{protocolo}"}, {"{cnpj}"}.</DialogDescription>
          </DialogHeader>
          <Input value={title} maxLength={150} onChange={(e) => setTitle(e.target.value)} className={fieldCls} data-testid="redeem-message-title" />
          <Textarea value={content} maxLength={3000} onChange={(e) => setContent(e.target.value)} className={`${fieldCls} min-h-[140px]`} data-testid="redeem-message-content" />
          <DialogFooter>
            <button onClick={() => setOpen(false)} className="btn-ghost-sm" data-testid="redeem-complete-cancel">Cancelar</button>
            <button onClick={complete} disabled={busy || !title.trim() || !content.trim()} className="btn-gold h-9 px-4 text-sm" data-testid="redeem-complete-confirm">Confirmar conclusão</button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </Panel>
  );
};
